import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class inventarioService {
    /******* QUERIES ******/

    async establecimientoAlmacen(filter) {
        const response = await axios
            .get(`${ERP}logistica/inventario/establecimiento-almacen?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async producto(filter) {
        const response = await axios
            .get(`${ERP}logistica/inventario/producto?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async inventarioValorizado(filter) {
        const response = await axios
            .get(`${ERP}logistica/inventario/inventario-valorizado/movimiento?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async unidadesFisicas(filter) {
        const response = await axios
            .get(`${ERP}logistica/inventario/unidades-fisicas/movimiento?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excelDetallado(filter) {
        const response = await axios
            .get(`${ERP}logistica/inventario/excel-detallado?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }; 
    
    async excelResumido(filter) {
        const response = await axios
            .get(`${ERP}logistica/inventario/excel-resumido?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };   
}

export default new inventarioService();